import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getCreatorVideos, type CreatorVideo } from '../services/datocms';

export const useCreatorStore = defineStore('creator', () => {
  const videos = ref<CreatorVideo[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  const fetchVideos = async () => {
    loading.value = true;
    error.value = null;
    try {
      videos.value = await getCreatorVideos();
    } catch (err) {
      error.value = err instanceof Error ? err.message : 'Failed to fetch videos';
    } finally {
      loading.value = false;
    }
  };

  return {
    videos,
    loading,
    error,
    fetchVideos,
  };
}); 